export const questionsList = [
  {
    id: 1,
    question: '✨ Answer a Few Easy Questions to Begin Your Personalized AI Journey! ✨',
    options: [
      {
        option: 'A',
        description: 'start',
        result: ''
      }
    ]
  },
  {
    id: 1,
    question: '🌟 How comfortable are you with technology in general?',
    options: [
      {
        option: 'A',
        description: '🤔 I’m just getting started',
        result: 'Start with basic tools like Google Docs AI features or Canva.'
      },
      {
        option: 'B',
        description: '📱 I can handle basic apps and tools',
        result: 'Explore accessible tools like Grammarly, ChatGPT Free, and AI-powered mobile apps.'
      },
      {
        option: 'C',
        description: '🧠 I’m pretty tech-savvy',
        result: 'Use tools like Zapier for automation or advanced Google Workspace AI tools.'
      },
      {
        option: 'D',
        description: '🖥️ I’m a total tech wizard',
        result: 'Experiment with APIs, like OpenAI API, and explore advanced integrations.'
      }
    ]
  },
  {
    id: 2,
    question: '🤖 Have you used AI tools before, like ChatGPT or image generators?',
    options: [
      {
        option: 'A',
        description: '👶 Nope, this is all new to me',
        result: 'Start with beginner-friendly tools like ChatGPT Free or Bing AI.'
      },
      {
        option: 'B',
        description: '🔍 I’ve tried a couple of them',
        result: 'Experiment with DALL·E, Jasper AI, or Notion AI for small projects.'
      },
      {
        option: 'C',
        description: '🎯 I use them occasionally',
        result: 'Use tools like Runway for video creation and MidJourney for creative AI.'
      },
      {
        option: 'D',
        description: '🌐 I use AI tools all the time',
        result: 'Explore building custom solutions with APIs or deep integrations using tools like Auto-GPT.'
      }
    ]
  },
  {
    id: 3,
    question: '🎯 What’s your main reason for wanting to learn how to use AI?',
    options: [
      {
        option: 'A',
        description: '🤩 Just curious—it seems cool',
        result: 'Use fun, interactive tools like Character.AI or AI Dungeon.'
      },
      {
        option: 'B',
        description: '⏳ To make my life easier or more productive',
        result: 'Try productivity tools like Trello AI, Notion AI, or Grammarly Premium.'
      },
      {
        option: 'C',
        description: '📈 To use it in my job or business',
        result: 'Explore task-specific tools like Tableau for data, or HubSpot AI for marketing.'
      },
      {
        option: 'D',
        description: '👩‍🏫 To help others understand and use AI',
        result: 'Use educational platforms like edX or Coursera for broader understanding.'
      }
    ]
  },
  {
    id: 4,
    question: '📚 How do you feel about learning new apps and tools?',
    options: [
      {
        option: 'A',
        description: '😰 It’s a bit intimidating',
        result: 'Follow structured tutorials on YouTube or Khan Academy.'
      },
      {
        option: 'B',
        description: '😊 I’m okay with it as long as it’s simple',
        result: 'Use tools with simple onboarding, like Canva AI or Jasper.'
      },
      {
        option: 'C',
        description: '🚀 I enjoy learning new tools',
        result: 'Dive into versatile tools like Zapier and Otter AI for workflows.'
      },
      {
        option: 'D',
        description: '🌟 I’m always on the lookout for the next big thing',
        result: 'Experiment with new tools in beta, like Google’s AI Test Kitchen.'
      }
    ]
  },
  {
    id: 5,
    question: '🎯 Do you want to focus on AI for specific tasks?',
    options: [
      {
        option: 'A',
        description: '🤷 Not sure yet',
        result: 'Explore general-purpose AI tools like ChatGPT and Canva AI.'
      },
      {
        option: 'B',
        description: '✍️ Writing and content creation',
        result: 'Learn about writing-specific tools like Jasper AI, Copy.ai, and Grammarly.'
      },
      {
        option: 'C',
        description: '🎨 Image or video editing',
        result: 'Experiment with creative tools like MidJourney, DALL·E, and Runway.'
      },
      {
        option: 'D',
        description: '📊 Business tasks like data analysis or customer service',
        result: 'Use business-focused tools like Tableau, Salesforce Einstein, or Looker.'
      }
    ]
  },
  {
    id: 6,
    question: '⏰ How much time can you spend learning AI each week?',
    options: [
      {
        option: 'A',
        description: '🕐 Less than an hour',
        result: 'Use apps with minimal time commitment, like ChatGPT or Grammarly.'
      },
      {
        option: 'B',
        description: '🕑 1-2 hours',
        result: 'Spend time on guided tutorials, like Coursera’s AI for Everyone course.'
      },
      {
        option: 'C',
        description: '🕒 3-5 hours',
        result: 'Dedicate weekly hours to projects with tools like Kaggle and AI art generators.'
      },
      {
        option: 'D',
        description: '🕓 More than 5 hours',
        result: 'Engage with intensive certifications like Google AI or AWS AI.'
      }
    ]
  },
  {
    id: 7,
    question: '🔍 Do you like following step-by-step guides, or do you prefer experimenting?',
    options: [
      {
        option: 'A',
        description: '📖 Step-by-step all the way',
        result: 'Use platforms like Udemy with step-by-step courses.'
      },
      {
        option: 'B',
        description: '🔄 A mix of both',
        result: 'Combine guides and experimentation with tools like Canva and Jasper.'
      },
      {
        option: 'C',
        description: '🛠️ I love figuring things out on my own',
        result: 'Take on open-ended challenges using tools like GitHub Copilot.'
      }
    ]
  },
  {
    id: 8,
    question: '🛠️ What kind of support do you prefer while learning?',
    options: [
      {
        option: 'A',
        description: '🎥 Clear tutorials and videos',
        result: 'Watch detailed YouTube tutorials for tools like DALL·E and Jasper.'
      },
      {
        option: 'B',
        description: '📄 Short articles or guides',
        result: 'Read blog posts and articles on sites like Towards Data Science.'
      },
      {
        option: 'C',
        description: '✍️ Hands-on practice with examples',
        result: 'Practice using interactive apps like ChatGPT and Notion AI.'
      },
      {
        option: 'D',
        description: '👥 Help from a community or group',
        result: 'Join forums like Reddit’s AI subreddits or Discord groups.'
      }
    ]
  },
  {
    id: 9,
    question: '📖 How do you usually learn new skills?',
    options: [
      {
        option: 'A',
        description: '🎥 Watching videos',
        result: 'Watch beginner courses on platforms like LinkedIn Learning.'
      },
      {
        option: 'B',
        description: '📄 Reading instructions',
        result: 'Read AI blogs and documentation for tools like OpenAI and Hugging Face.'
      },
      {
        option: 'C',
        description: '🛠️ Trying it out myself',
        result: 'Start projects immediately using tools like Kaggle.'
      },
      {
        option: 'D',
        description: '🔄 A mix of everything',
        result: 'Blend multiple approaches for broader mastery.'
      }
    ]
  },
  {
    id: 10,
    question: '💰 Do you want to focus on free tools or are you okay with paid ones?',
    options: [
      {
        option: 'A',
        description: '💸 Free only',
        result: 'Stick to free tools like ChatGPT Free, DALL·E Free, or Canva Free.'
      },
      {
        option: 'B',
        description: '💵 I’m okay with small costs',
        result: 'Explore low-cost tools like Jasper Starter Plan and Notion AI.'
      },
      {
        option: 'C',
        description: '💎 I’m open to investing if it’s worth it',
        result: 'Invest in premium tools like Grammarly Premium or MidJourney Pro.'
      }
    ]
  },
  {
    id: 11,
    question: '📊 Are you interested in using AI for personal projects or work?',
    options: [
      {
        option: 'A',
        description: '🎨 Mostly personal projects',
        result: 'Use tools for personal creativity, like AI Dungeon or Runway.'
      },
      {
        option: 'B',
        description: '🏢 Mostly for work',
        result: 'Try business-oriented tools like Salesforce Einstein or Tableau.'
      },
      {
        option: 'C',
        description: '⚖️ Both equally',
        result: 'Balance personal and business projects with versatile tools like Zapier.'
      }
    ]
  },
  {
    id: 12,
    question: '✨ What excites you most about AI?',
    options: [
      {
        option: 'A',
        description: '✅ Making everyday tasks easier',
        result: 'Use tools for daily organization, like Otter AI and Todoist AI.'
      },
      {
        option: 'B',
        description: '🎨 Creating cool things like art or stories',
        result: 'Create art and content with tools like DALL·E and Canva.'
      },
      {
        option: 'C',
        description: '⚙️ Solving problems or improving efficiency',
        result: 'Automate workflows using Zapier and Airtable AI.'
      },
      {
        option: 'D',
        description: '🚀 Exploring its potential for the future',
        result: 'Follow cutting-edge AI news and experimental tools like Auto-GPT.'
      }
    ]
  },
  {
    id: 13,
    question: '⚖️ Are you interested in learning about AI ethics?',
    options: [
      {
        option: 'A',
        description: '❌ Not really',
        result: 'Skip ethics-focused content for now.'
      },
      {
        option: 'B',
        description: '🧐 A little bit',
        result: 'Read accessible articles on AI ethics, like those from OpenAI.'
      },
      {
        option: 'C',
        description: '📚 I’m very interested',
        result: 'Take AI ethics courses on platforms like Coursera or Udemy.'
      }
    ]
  },
  {
    id: 14,
    question: '🤝 Do you enjoy collaborating with others when learning new skills?',
    options: [
      {
        option: 'A',
        description: '👤 I prefer working alone',
        result: 'Use solo-focused tools and resources like LinkedIn Learning.'
      },
      {
        option: 'B',
        description: '👥 I enjoy some collaboration',
        result: 'Join small group discussions on platforms like Discord.'
      },
      {
        option: 'C',
        description: '🌍 I love learning with others',
        result: 'Participate in collaborative projects on Kaggle or GitHub.'
      }
    ]
  },
  {
    id: 15,
    question: '🎨 What’s your preferred way of engaging with AI tools?',
    options: [
      {
        option: 'A',
        description: '😃 Casually, for fun or curiosity',
        result: 'Explore interactive tools like Character.AI or AI Dungeon.'
      },
      {
        option: 'B',
        description: '📈 Professionally, to improve productivity',
        result: 'Use tools like Grammarly Premium, Notion AI, or Salesforce Einstein.'
      },
      {
        option: 'C',
        description: '🎭 For creative expression',
        result: 'Experiment with tools like DALL·E, MidJourney, and Runway.'
      },
      {
        option: 'D',
        description: '🛠️ To push the boundaries of what’s possible',
        result: 'Explore experimental tools like Auto-GPT and AI research platforms.'
      }
    ]
  }
];
